import {createReducer} from 'redux-act';
import {ClockType, PressureUnit, SpeedUnit, TemperatureUnit} from '@/common/constants/units';
import {DomainConfig, Preferences} from '@/app/interfaces/preferences';
import {RouteKeywordsMap} from '@/app/interfaces/routing';
import * as actions from './actions';

const initialState = {
	// Domain-related static config
	domain: {
		domainName: '',
		countryId: '',
		routeKeywords: {} as RouteKeywordsMap,
		primaryLanguage: '',
		supportedLanguages: [],
		bannersSet: '',
	} as DomainConfig,

	// User's personal preferences
	preferencesReady: false,
	preferences: {
		temperatureUnit: TemperatureUnit.celsius,
		pressureUnit: PressureUnit.mmHg,
		speedUnit: SpeedUnit.ms,
		clockType: ClockType['24h'],
		weatherViewMode: 'plot',
		weatherViewHiddenFields: [],
	} as Preferences,
	noAds: false,
};

export const configReducer = createReducer({}, initialState);

configReducer
	.on(actions.setDomainConfigAction, (state, domain) => ({
		...state,
		domain,
	}))
	.on(actions.setPreferencesAction, (state, preferences) => ({
		...state,
		preferencesReady: true,
		preferences: {
			...state.preferences,
			...preferences,
		},
	}))
	.on(actions.fetchPreferencesAction.success, (state, preferences) => ({
		...state,
		preferencesReady: true,
		preferences: {
			...state.preferences,
			...preferences,
		},
	}))
	.on(actions.updatePreferencesAction.request, (state, preferences) => ({
		...state,
		preferences: {...state.preferences, ...preferences},
	}))
	.on(actions.fetchDefaultLocationInfoAction.success, (state, defaultLocationInfo) => ({
		...state,
		preferences: {...state.preferences, defaultLocationInfo},
	}))
	.on(actions.setNoAdsAction, (state, noAds) => ({
		...state,
		noAds,
	}));
